// Componente "Gallery" condiviso da singolo Servizio e singola Collaborazione
// (template-parts/partials/gallery.php): griglia di foto con "carica altro"
// opzionale (assets/js/load-more-grid.js) + visualizzatore a schermo intero
// condiviso da tutte le foto della sezione (anche quelle ancora [hidden]
// nella griglia "carica altro", quando presente: le frecce prec./succ.
// scorrono l'intera galleria, non solo le foto già rivelate).
import { createLoadMoreGrid } from "./load-more-grid";

function initGalleryGrid(section) {
    const grid = section.querySelector("[data-gallery-grid]");

    if (!grid) {
        return;
    }

    const items = Array.from(grid.querySelectorAll("[data-gallery-item]"));

    // Il "carica altro" è opzionale (vedi template-parts/partials/gallery.php,
    // $args['load_more']): senza data-gallery-initial-count sulla sezione, il
    // markup PHP mostra già tutte le foto e non c'è altro da fare qui.
    const initialCount = parseInt(section.dataset.galleryInitialCount || "", 10);

    if (!initialCount) {
        return;
    }

    const loadIncrement = parseInt(section.dataset.galleryLoadIncrement || "", 10) || initialCount;
    const bigIndexes = (grid.dataset.galleryBigIndexes || "")
        .split(",")
        .filter(Boolean)
        .map(Number);

    const loadMoreWrap = section.querySelector("[data-gallery-load-more-wrap]");
    const loadMoreButton = section.querySelector("[data-gallery-load-more]");
    const showLessButton = section.querySelector("[data-gallery-show-less]");
    const shownCountLabel = section.querySelector("[data-gallery-shown-count]");

    const loadMoreGrid = createLoadMoreGrid({
        getItems: () => items,
        initialCount,
        loadIncrement,
        loadMoreWrap,
        loadMoreButton,
        showLessButton,
        onRender({ shown, total, visibleLimit }) {
            const stillDefault = visibleLimit <= initialCount;
            bigIndexes.forEach((index) => {
                const item = items[index];
                if (item) {
                    item.classList.toggle("gallery__item--big", stillDefault);
                }
            });

            if (shownCountLabel) {
                shownCountLabel.textContent = total > initialCount ? `Mostrate ${shown} di ${total} foto` : "";
            }
        },
    });

    loadMoreGrid.render();
}

function initGalleryLightbox(section) {
    const lightbox = document.querySelector("[data-gallery-lightbox]");
    const items = Array.from(section.querySelectorAll("[data-gallery-item]"));

    if (!lightbox || !items.length) {
        return;
    }

    const image = lightbox.querySelector("[data-gallery-image]");
    const counter = lightbox.querySelector("[data-gallery-counter]");
    const closeButton = lightbox.querySelector("[data-gallery-close]");
    const prevButton = lightbox.querySelector("[data-gallery-prev]");
    const nextButton = lightbox.querySelector("[data-gallery-next]");

    let currentIndex = -1;

    function show(index) {
        currentIndex = (index + items.length) % items.length;
        const item = items[currentIndex];

        if (image) {
            image.src = item.dataset.full || "";
            image.alt = item.dataset.caption || "";
        }

        if (counter) {
            counter.textContent = `${currentIndex + 1} / ${items.length}`;
        }
    }

    function onKeydown(event) {
        if (event.key === "Escape") {
            close();
        } else if (event.key === "ArrowRight") {
            show(currentIndex + 1);
        } else if (event.key === "ArrowLeft") {
            show(currentIndex - 1);
        }
    }

    function open(index) {
        show(index);
        lightbox.hidden = false;
        document.body.classList.add("has-gallery-lightbox");
        document.addEventListener("keydown", onKeydown);
    }

    function close() {
        lightbox.hidden = true;
        document.body.classList.remove("has-gallery-lightbox");
        document.removeEventListener("keydown", onKeydown);

        if (image) {
            image.src = "";
        }

        const trigger = items[currentIndex];
        if (trigger) {
            trigger.focus();
        }
    }

    items.forEach((item, index) => {
        item.addEventListener("click", () => open(index));
    });

    if (closeButton) {
        closeButton.addEventListener("click", close);
    }

    if (prevButton) {
        prevButton.addEventListener("click", () => show(currentIndex - 1));
    }

    if (nextButton) {
        nextButton.addEventListener("click", () => show(currentIndex + 1));
    }

    // Click sullo sfondo (fuori dallo stage e dai controlli) per chiudere.
    lightbox.addEventListener("click", (event) => {
        if (event.target === lightbox) {
            close();
        }
    });
}

export function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach((section) => {
        initGalleryGrid(section);
        initGalleryLightbox(section);
    });
}
